export const GET_FAMILY_MEMBERS_SUCCESS = 'GET_FAMILY_MEMBERS_SUCCESS';
export const GET_FAMILY_MEMBERS_PENDING = 'GET_FAMILY_MEMBERS_PENDING';
export const GET_FAMILY_MEMBERS_ERROR = 'GET_FAMILY_MEMBERS_ERROR';
export const UPDATE_FAMILY_MEMBERS_ADDRESS_SUCCESS = 'UPDATE_FAMILY_MEMBERS_ADDRESS_SUCCESS';
export const UPDATE_FAMILY_MEMBERS_ADDRESS_PENDING = 'UPDATE_FAMILY_MEMBERS_ADDRESS_PENDING';
export const UPDATE_FAMILY_MEMBERS_ADDRESS_ERROR = 'UPDATE_FAMILY_MEMBERS_ADDRESS_ERROR';
export const GET_POSTAL_CODES_FOR_ADDRESS_SUCCESS = 'GET_POSTAL_CODES_FOR_ADDRESS_SUCCESS';
export const GET_POSTAL_CODES_FOR_ADDRESS_PENDING = 'GET_POSTAL_CODES_FOR_ADDRESS_PENDING';
export const GET_POSTAL_CODES_FOR_ADDRESS_ERROR = 'GET_POSTAL_CODES_FOR_ADDRESS_ERROR';
